module.exports = __webpack_public_path__ + "img/tpc-brochures-1.c822dad8.jpg";